import React from "react";

import { useField } from "formik";

import { DateInput } from "components/Form";
import { Label } from "components/Form/FormikControls";
import { withNamespace } from "components/Form/FormikControls/lib";
import { Column } from "components/Layout";
import theme from "constants/theme";

interface WhenTabProps {
  saleNamespace: string;
}

export const WhenTab = ({ saleNamespace }: WhenTabProps) => {
  const fieldName = withNamespace(saleNamespace, "date");
  const [field, meta] = useField(fieldName);

  return (
    <Column fullWidth marginVertical={2}>
      <Label required error={meta.touched && !!meta.error}>
        Sale Date
      </Label>
      <DateInput
        {...field}
        error={meta.touched && !!meta.error}
        includeTime={false}
        style={{ backgroundColor: theme.colors.white }}
      />
    </Column>
  );
};
